<template>

  <!-- Header -->
  <header class="header sticky-header">

    <!-- Header Top Area -->
    <div  class="header-top-area h-5-px">

    </div>
    <!--// Header Top Area -->

    <!-- Header Middle Area -->
    <div v-show="true"  class="header-middle-area cr-border cr-border-bottom">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-4 col-12">
          </div>
          <div class="col-lg-4 col-md-6 col-sm-7 col-12">
            <div class="header-logo" style="padding:0px">
              <a href="/">
                <img src="/img/logo/logo.png"  alt="BUKIBAGS.COM">
              </a>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 col-sm-5 col-12 mt-0">

            <form action="/fashion-handbags/view-all" class="header-search mr-0">
              <input type="text" name="keyword" placeholder="Search product...">
              <button type="submit"><i class="fa fa-search"></i></button>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!--// Header Middle Area -->

    <!-- Header Bottom Area -->
    <div class="header-bottom-area d-none d-lg-block">
      <div class="container">
        <div class="header-bottom-inner">
          <nav class="sn-navigation">
            <ul>
              <li><router-link :to="{ name: 'product', params: { path: 'new-arrivals',newStatus:1,name:'NEW ARRIVALS' }}">NEW ARRIVALS</router-link></li>
              <li v-for="category in categoryList"><router-link :to="{ name: 'product', params: { path: category.path,id:category.id,name:category.name }}">{{category.name}}</router-link></li>
            </ul>
          </nav>
          <div class="header-bottom-social">
            <span>Follow Us On:</span>
            <share></share>
          </div>
        </div>
      </div>
    </div>
    <!--// Header Bottom Area -->

    <!-- Header Mobile Menu -->
    <div class="mobile-menu-area d-block d-lg-none">
      <div class="container">
        <div class="mobile-menu clearfix">
          <div class="header-bottom-social">
            <span>Follow Us On:</span>
            <share></share>
          </div>
        </div>
      </div>
    </div>
    <!--// Header Mobile Menu -->

  </header>
</template>

<script>
    import request from '@/utils/request'
    import share from '@/components/share'
    export default {
        name: "header-com",
        components:{
          share
        },
        data(){
          return {
                    categoryList:[]
                  }
        },
        mounted(){
          const  _this = this
          request({
            url: '/productCategory/list/0',
            method: 'get',
          }).then(res=>{
            if(res.data.code===200) {
              _this.categoryList = res.data.data
              setTimeout(function(){
                /* Mobile Menu */
                $('nav.sn-navigation').meanmenu({
                  meanMenuClose: '<img src="/img/icons/icon-close.png" alt="close icon">',
                  meanMenuCloseSize: '18px',
                  meanScreenWidth: '991',
                  meanExpandableChildren: true,
                  meanMenuContainer: '.mobile-menu',
                  onePage: true
                });

              },200)
            }
          })

          $('select').niceSelect()
        }
    }
</script>

<style scoped>

</style>
